import { all } from 'redux-saga/effects';

import global from './global';
import authenticate from './authenticate';
import ticket from './ticket';

function* saga() {
  yield all([...global, ...authenticate, ...ticket]);
}

export default saga;
